import React from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import { translate } from 'components/Translation';
import { BodyMBold } from 'components/Typography/Typography';
import CustomInput from 'components/CustomInput/CustomInput';

interface IAddEmailDialogProps {
	isDialogOpen: boolean;
	hideDialog: () => void;
	formData: FormData;
	onChange: (name: keyof FormData, value: string) => void;
	isValid: boolean;
	onSubmit: () => void;
}

interface FormData {
	newEmail: string;
}

interface IFormProps {
	formData: FormData;
	onChange: (name: keyof FormData, value: string) => void;
	isValid: boolean;
}

const Form = (props: IFormProps) => {
	const { formData, onChange } = props;
	return (
		<form
			style={{ maxWidth: '300px' }}
			onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
				event.preventDefault();
			}}
		>
			<CustomInput
				labelText={translate('users.details.changeUserType.email')}
				id="newEmail"
				inputProps={{
					required: true,
					value: formData.newEmail,
					type: 'string',
					onChange: (event: React.FormEvent<HTMLInputElement>) =>
						onChange('newEmail', (event.target as HTMLInputElement).value),
				}}
				formControlProps={{
					fullWidth: true,
				}}
			/>
		</form>
	);
};

const AddEmailDialog = ({ isDialogOpen, hideDialog, formData, onChange, isValid, onSubmit }: IAddEmailDialogProps) => {
	const cancelAction = () => {
		hideDialog();
	};

	return (
		<ConfirmationDialog
			isOpen={isDialogOpen}
			hideDialog={hideDialog}
			buttons={[
				{
					text: translate('cancel'),
					onClick: cancelAction,
					color: 'tertiary-light' as types.theme.buttonColor,
				},
				{
					text: translate('users.details.changeUserType.addEmail'),
					onClick: onSubmit,
					disabled: !isValid,
					color: 'primary-light' as types.theme.buttonColor,
				},
			]}
			withIcon={false}
			header={translate('users.details.changeUserType.addEmail')}
			dialogBody={
				<>
					<BodyMBold color="danger">
						{translate(`users.details.changeUserTypeWarning.changeFromEnduser`)}
					</BodyMBold>
					<Form formData={formData} onChange={onChange} isValid={isValid} />
				</>
			}
		/>
	);
};

export default AddEmailDialog;
